import { Autocomplete, TextField } from "@mui/material";
import { useCentroCustoStore } from "../../stores/comercial/centrocusto";
import { useEffect } from "react";


interface Props {
  value: number | null
  onChange: (value: number | null) => void
  required?: boolean
  erro?: boolean
  messageErro?: string
  disabled?: boolean
}

function CentroCustoSelect({ value, onChange, required = false, erro = false, messageErro = "", disabled = false }: Props) {
  const { centroCustoResume, setCentroCustoResume, loadingCentroCustoResume, erroCentroCustoResume, setErroCentroCustoResume } = useCentroCustoStore()

  useEffect(() => {
    if (centroCustoResume.length === 0) {
      setCentroCustoResume()
    }
  }, [])

  return (
    <Autocomplete
      id="centro-custo-select"
      disabled={disabled}
      options={centroCustoResume}
      onOpen={async () => {
        if (centroCustoResume.length === 0) {
          await setCentroCustoResume()
        }
        else {
          setErroCentroCustoResume(false)
        }
      }}
      value={value != null ? centroCustoResume.find((option) => option.idCentroCusto == value) : null}
      getOptionLabel={(option) => `${option.codigo} - ${option.descricao}`}
      onChange={(event, newValue) => {
        onChange(newValue?.idCentroCusto ?? null)
      }}
      isOptionEqualToValue={(option, selectedOption) => option.idCentroCusto === selectedOption.idCentroCusto}
      getOptionKey={(x) => x.idCentroCusto}
      filterSelectedOptions
      loading={loadingCentroCustoResume}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          disabled={disabled}
          size="small"
          label="Centro de custo"
          error={erroCentroCustoResume || erro}
          helperText={erroCentroCustoResume == true ? "Houve algum erro ao buscar os centros de custo" : (erro == true ? messageErro : "")}
        />
      )}
    />
  );
}

export default CentroCustoSelect;